import parametrizacaoRepository from './parametrizacaoRepository'

export default baseUrl => {
    return {
        parametrizacao: parametrizacaoRepository(baseUrl),
    }
}
